// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bxxrXkMHbiUlFH {
  grid-area: statetaxid;
}
label.vgnYslTsieZlI5 {
  display: inline-flex;
}
.iCWdGJnBg7gB5t {
  display: block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"isVatRegistered": `bxxrXkMHbiUlFH`,
	"vatCheckbox": `vgnYslTsieZlI5`,
	"vatCheckboxContainer": `iCWdGJnBg7gB5t`
};
export default ___CSS_LOADER_EXPORT___;
